/**
 * A Gathering guest's identity (backend: services/gathering_guests.py) — what
 * POST /api/gathering/guest/join returned, kept in this browser until it
 * expires. A guest has no Keycloak session; this is their only credential,
 * and the backend accepts it on the Gathering member routes only.
 *
 *   saveGuest({ user_id, person_id, name, expires_at });
 *   readGuest();    // the guest, or null if there's none or it has expired
 *   guestStatus();  // 'active' | 'expired' | 'none'
 *   clearGuest();
 */

import { parseServerTime } from './gathering';

const KEY = 'gathering.guest';

function load() {
    try {
        const raw = localStorage.getItem(KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function saveGuest(guest) {
    try { localStorage.setItem(KEY, JSON.stringify(guest)); } catch { /* private mode: lasts this page only */ }
}

export function clearGuest() {
    try { localStorage.removeItem(KEY); } catch { /* nothing stored */ }
}

export function guestStatus(now = Date.now()) {
    const guest = load();
    if (!guest?.user_id) return 'none';
    // expires_at is the backend's naive-UTC timestamp.
    const expiresAt = parseServerTime(guest.expires_at);
    return expiresAt != null && expiresAt > now ? 'active' : 'expired';
}

export function readGuest(now = Date.now()) {
    return guestStatus(now) === 'active' ? load() : null;
}

/**
 * Whether a person (a GatheringPerson from the backend, or an entity the
 * admin view got from /api/entities) is a Gathering guest — for the tag.
 */
export const isGuestPerson = p => !!(p?.is_guest || p?.attributes?.is_guest);
